import React, {useEffect, useState} from "react";
import User from "../../Models/User";
import {
    Alert,
    Box,
    Button,


    Checkbox, Chip,
    Container,  Drawer, FormControl, FormControlLabel, FormGroup,
    Grid, InputAdornment, InputLabel,
    OutlinedInput,
    Paper, Select, Switch,
    Typography,

} from "@mui/material";
import MainLayout from "../MainLoyout/MainLayout";
import {useSelector} from 'react-redux'
import Api from "../../Services/Api";
import {DataGrid, GridActionsCellItem, GridToolbar} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import TextField from '@mui/material/TextField';
import Title from "../Title";
import {
   AddCircle,
    Circle,
    Edit, QueryStats,
    SmartToy,
    Traffic
} from "@mui/icons-material";
import {ContentCopy} from "@mui/icons-material";
import MenuItem from "@mui/material/MenuItem";
import Success from "../Snackbar/Success";
import { useSearchParams} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import SupplyFeedDetailsTable from "../Admin/SupplyFeedDetailsTable";
import SelectOptionDialog from "../SelectOptionDialog";
import SupplyFeedsModal from "./SupplyFeedsModal";


const SupplyFeeds = () => {



    const [open, setOpen] = React.useState(false);
    const [openSupplyFeeds, setOpenSupplyFeeds] = React.useState(false);
    const [row, setRow] = React.useState(null);



    const [form, setForm] = React.useState({});
    const [edit, setEdit] = React.useState(false);
    const [editMessage, setEditMessage] = React.useState(null);
    let [searchParams, setSearchParams] = useSearchParams();
    const daysToFollowup = 5


    const [demandPartners, setDemandPartners] = React.useState([]);
    const [keywordsList, setKeywordsList] = React.useState([]);

    const [supplyPartners, setSupplyPartners] = React.useState([]);
    const [supplyFeeds, setSupplyFeeds] = React.useState([]);
    const [demandFeeds, setDemandFeeds] = React.useState([]);
    const [demandFeedTypes, setDemandFeedTypes] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [openDetails, setOpenDetails] = React.useState(false);
    const [detailsId, setDetailsId] = React.useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = React.useState(false);
    const [selectedValueDetails, setSelectedValueDetails] = React.useState(null);
    const [optionsDialogDetails, setOptionsDialogDetails] = React.useState([]);





    useEffect(() => {

        loadData()
    }, []);

    const loadData = async () => {
        setLoading(true)
        await Api.demand().then(r => {
            setDemandFeeds(r)
        })

        await Api.demandPartners().then(r => {
            setDemandPartners(Object.values(r))
        })

        await Api.supplyPartners().then(r => {
            setSupplyPartners(Object.values(r))
        })

        await Api.keywordsList().then(r => {
            setKeywordsList(Object.values(r))
        })

        await Api.demandTypes().then(r => {
            setDemandFeedTypes(Object.values(r))
        })
        setLoading(false)
    }


    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(40)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );


    const onCellEditCommit = (params, event) => {
        Api.updateDemandFeed(params).then(r => console.log(r))
    }


    const columns = [
        {
            field: "id",
            headerName: "Id",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 50

        },
        {
            field: "status",
            headerName: "Status",
            type: 'string',
            editable: false,
            flex: 0.45,
            minWidth: 150,
            valueGetter: (params) => {

                let status = "NA"

                if (params.row?.status !== 1) {
                    status = "Demand Paused"
                } else if (params.row?.supply_feeds.length > 0 && params.row?.supply_feeds[0]?.active !== 1) {
                    status = "Feed Paused"
                } else if (params.row?.supply_feeds.length > 0) {

                    if (!params.row?.supply_feeds[0]?.user.is_admin) {
                        let today = new Date()
                        const offset = today.getTimezoneOffset()
                        today = new Date(today.getTime() - (offset * 60 * 1000)).toISOString().split('T')[0]
                        const found = params.row?.daily_stats?.filter(stats => {
                            return stats.date == today;
                        });

                        let yesterday = new Date()
                        yesterday.setDate(yesterday.getDate() - 1);
                        yesterday = new Date(yesterday.getTime() - (offset * 60 * 1000)).toISOString().split('T')[0]

                        const foundYesterday = params.row?.daily_stats?.filter(stats => {
                            return stats.date == yesterday;
                        });

                        const dateFeed = new Date(params.row?.supply_feeds[0].created_at)
                        let fiveDaysAgo = new Date()
                        fiveDaysAgo.setDate(fiveDaysAgo.getDate()-daysToFollowup);


                        if (found.length && found[0]?.searches >= 200) status = "Running"
                        else if (found.length && found[0]?.searches > 0 && found[0]?.searches < 200) status = "Low volumes"
                        else if ((foundYesterday.length && foundYesterday[0]?.searches > 200 && found.length == 0) || (foundYesterday.length && foundYesterday[0]?.searches > 200 && found.length && found[0]?.searches == 0)) status = "Traffic Paused"
                        else if (dateFeed < fiveDaysAgo) status = "Need Follow up"
                        else status = "Pending"
                    } else {
                        status = "Unknown"
                    }

                } else {
                    status = "Not assigned"
                }

                return status

            },
            renderCell: (params) => {
                let status = "NA"

                if (params.row?.status !== 1) {
                    status =
                        <React.Fragment> <Circle color={"error"} fontSize={"small"} sx={{mr: 1}}></Circle> Demand Paused
                        </React.Fragment>
                } else if (params.row?.supply_feeds.length > 0 && params.row?.supply_feeds[0]?.active !== 1) {
                    status = <React.Fragment> <Circle color={"disabled"} fontSize={"small"} sx={{mr: 1}}></Circle> Feed
                        Paused </React.Fragment>
                } else if (params.row?.supply_feeds.length > 0) {

                    let today = new Date()
                    const offset = today.getTimezoneOffset()
                    today = new Date(today.getTime() - (offset * 60 * 1000)).toISOString().split('T')[0]
                    const found = params.row?.daily_stats?.filter(stats => {
                        return stats.date == today;
                    });

                    if (!params.row?.supply_feeds[0]?.user.is_admin) {
                        let yesterday = new Date()
                        yesterday.setDate(yesterday.getDate() - 1);
                        yesterday = new Date(yesterday.getTime() - (offset * 60 * 1000)).toISOString().split('T')[0]

                        const foundYesterday = params.row?.daily_stats?.filter(stats => {
                            return stats.date == yesterday;
                        });

                        const dateFeed = new Date(params.row?.supply_feeds[0].created_at)
                        let fiveDaysAgo = new Date()
                        fiveDaysAgo.setDate(fiveDaysAgo.getDate()-daysToFollowup);

                        if (found.length && found[0]?.searches >= 200) status =
                            <React.Fragment> <Circle color={"success"} fontSize={"small"} sx={{mr: 1}}></Circle> Running
                            </React.Fragment>
                        else if (found.length && found[0]?.searches > 0 && found[0]?.searches < 200) status =
                            <React.Fragment> <Circle color={"secondary"} fontSize={"small"} sx={{mr: 1}}></Circle> Low
                                volumes
                            </React.Fragment>
                        else if ((foundYesterday.length && foundYesterday[0]?.searches > 200 && found.length == 0) || (foundYesterday.length && foundYesterday[0]?.searches > 200 && found.length && found[0]?.searches == 0)) status =
                            <React.Fragment> <Circle color={"secondary"} fontSize={"small"}
                                                     sx={{mr: 1}}></Circle> Traffic Paused
                            </React.Fragment>
                        else if (dateFeed < fiveDaysAgo) status =  <React.Fragment> <Circle color={"secondary"} fontSize={"small"}
                                                                                            sx={{mr: 1}}></Circle> Need Follow up
                        </React.Fragment>

                        else status =
                                <React.Fragment> <Circle color={"info"} fontSize={"small"}
                                                         sx={{mr: 1}}></Circle> Pending
                                </React.Fragment>
                    } else {
                        status = <React.Fragment> <Circle color={"inherit"} fontSize={"small"}
                                                          sx={{mr: 1}}></Circle> Unknown
                        </React.Fragment>
                    }
                } else {
                    status = <React.Fragment> <Circle color={"warning"} fontSize={"small"} sx={{mr: 1}}></Circle> Not
                        Assigned </React.Fragment>
                }

                return status
            }

        },
        {
            field: "user_name",
            headerName: "Demand",
            type: 'string',
            editable: false,
            flex: 0.4,
            minWidth: 150,
            valueGetter: (params) => params.row?.user?.name
        },
        {
            field: "supply",
            headerName: "Supply",
            type: 'string',
            editable: false,
            flex: 0.4,
            hide: false,
            minWidth: 150,
            valueGetter: (params) => params.row?.supply_feeds?.length ? params.row?.supply_feeds?.filter(item => item.active).map(item => item.user.name) : '-'

        },
        {
            field: "feed_id",
            headerName: "Feed Id",
            type: 'string',
            editable: false,
            flex: 0.2,
            hide: false,
            minWidth: 100,
            valueGetter: (params) => params.row?.supply_feeds?.length ? params.row?.supply_feeds?.map(item => item.id) : '-'

        },


        {
            field: "user_demand_provider",
            headerName: "Demand Provider",
            type: 'string',
            editable: false,
            flex: 0.4,
            hide: true,
            minWidth: 150,
            valueGetter: (params) => params.row?.user?.demand_provider_name
        },


        {
            field: "tags",
            headerName: "Tags",
            type: 'string',
            editable: false,
            flex: 0.6,
            minWidth: 300,
            renderCell: (params) => {

                const tags = params.row?.tags ? JSON.parse(params.row?.tags) : null;


                return (
                    <div>
                        {tags?.map((item, key) => <Chip label={item} key={key} size={"small"} sx={{mr: 1}}/>)}
                    </div>
                )
            }
        },

        {
            field: "jumps",
            headerName: "Jumps",
            type: 'string',
            editable: false,
            flex: 0.1,
            minWidth: 70,
            valueGetter: (params) => {
                try {
                    const data = params.row?.checker_data ? JSON.parse(params.row.checker_data) : null;
                    return data?.jumps || null; // Safely access jumps
                } catch (error) {
                    console.error("Error parsing checker_data in valueGetter:", error);
                    return null; // Fallback to null if JSON parsing fails
                }
            },
            renderCell: (params) => {
                let jumps = null
                try {
                    if (params.row?.checker_data) {
                        const data = JSON.parse(params.row.checker_data);
                        jumps = Array.isArray(data.jumps) ? data.jumps.length : null;
                    }
                } catch (error) {
                    console.error("Error parsing checker_data or accessing jumps:", error);
                }
                return jumps ? (<a href={"#" + params.row.id + "checker"}  onClick={(e) => {e.preventDefault(); searchParams.set('checker', true); searchParams.set('data', params.row.checker_data);setSearchParams(searchParams) }}>{jumps} </a>) : ""
            }


        },
        {
            field: "data_checker",
            headerName: "Data Checker",
            type: 'string',
            editable: false,
            flex: 0.1,
            hide: true,
            minWidth: 70,
            valueGetter: (params) => params.row.checker_data ? params.row?.checker_data : null,


        },

        {
            field: "internal_name",
            headerName: "Internal Name",
            type: 'string',
            editable: false,
            flex: 0.1,
            hide: true,
            minWidth: 70,
            valueGetter: (params) => params.row?.supply_feeds?.length ? params.row?.supply_feeds?.map(item => item.internal_name) : '-'



        },

        {
            field: "needle",
            headerName: "Needle",
            type: 'string',
            editable: true,
            flex: 0.4,
            minWidth: 150,
        },
        {
            field: "url",
            headerName: "Url",
            type: 'string',
            editable: true,
            flex: 0.6,
            hide: true,
            minWidth: 200,

        },
        {
            field: "capping",
            headerName: "Cap",
            width: 100,
            type: 'number',
            editable: true,
            flex: 0.2,
            minWidth: 100,


        },
        {
            headerName: "Actions",
            field: 'actions',
            type: 'actions',
            flex: 0.4,
            minWidth: 200,
            getActions: (params) => [

                <GridActionsCellItem icon={<ContentCopy/>} onClick={() => copyRow(params.row)} label="Copy"/>,
                <GridActionsCellItem icon={<Edit/>} onClick={() => {
                    setSupplyFeeds(params.row.supply_feeds)
                    setEdit(true)
                    copyRow(params.row)
                }} label="Edit"/>,
                <GridActionsCellItem  disabled={!params.row.supply_feeds.length ? true:false} icon={<QueryStats/>} onClick={() => {

                        let options = []
                    params.row.supply_feeds?.map(item => options.push({id: item.id, name: item.user.name}))
                        setOptionsDialogDetails(options)
                        setRow(params.row)
                        handleClickOpenDetails()

                }} label="Details"/>,
                <GridActionsCellItem  icon={<Traffic/>} onClick={() => { setRow(params.row); setOpenSupplyFeeds(true) }} label="Supply Feeds"/>

            ]
        }
    ];




    const handleClickOpenDetails = () => {
        setOpenDetailsDialog(true);
    };

    const handleCloseDetails = (value) => {
        setOpenDetailsDialog(false);
        if(value) {
            setOpenDetails(true)
            setDetailsId(value);
        }
    };

    const copyRow = (data) => {


        setForm({})
        setForm(prevState =>
            ({
                ...prevState,
                id: data.id,
                needle: data.needle,
                type_id: data.type_id,
                demand_partner_id: data.user.id,
                url: data.url,
                internal_name: data.internal_name,
                capping: data.capping,
                mobile: (data.mobile === 1),
                desktop: (data.desktop === 1),
                note: data.note,
                status: (data.status === 1),
                supply_feeds: data.supply_feeds,

            })
        )
        // const supply_partner_id = data.supply_feeds[0]?.id
        //
        // //looking for the feed_id on redux
        // if (!isNaN(supply_partner_id) && typeof supply_partner_id !== 'undefined') {
        //     const supply_user_id = feeds.filter((item) => {
        //
        //         if (item.id == supply_partner_id) {
        //             return true
        //         }
        //         return false
        //     })
        //
        //     setForm(prevState =>
        //         ({
        //             ...prevState,
        //             supply_partner_id: supply_user_id[0].user_id,
        //         })
        //     )
        //
        //
        // }
        setOpen(true)


    }

    const handleSubmit = async (event) => {


        event.preventDefault();

        if (edit) {
            console.log('edit', form);
            Api.editDemandFeed(form).then(r => {

                // console.log(form, r)
                // let _data = rows.map((item) => {
                //
                //     if (item.id == r.data.id) {
                //         return r.data
                //     }
                //     return item
                // })
                //
                // setRows(_data)
                // updateDemandFeeds(_data).then(r => console.log('demand feeds updated'))
                //
                //
                // //we sync just in cases feeds changed
                // check().then(r => console.log('user updated'))

                loadData()


                setEdit(false)
                setOpen(false)

                setEditMessage(r)
            })

        } else {

            Api.createDemandFeed(form).then(r => {

                // let newRows = [r.data, ...rows]
                // setRows(newRows);
                // setSuccessMessage(true)
                // updateDemandFeeds(newRows).then(r => console.log('update demand feeds'))
                //
                // //if supply update feeds
                // if (r.data.supply_feeds.length) {
                //     let newFeeds = [r.data.supply_feeds[0], ...feeds]
                //     setFeeds(newFeeds);
                //     updateSupplyFeeds(newFeeds).then(r => console.log('update supply feeds'))
                //
                // }
                // setRows(newRows);
                loadData()

                setEditMessage(r)
                setOpen(false)


            })
        }
    }


    const handleChange = (event) => {

        let value = (event.target.name == "status" || event.target.name == "mobile" || event.target.name == "desktop") ? event.target.checked : event.target.value

        setForm(prevState =>
            ({
                ...prevState,
                [event.target.name]: value
            })
        )
    };

    const tier1Countries = [
        { code: 'ALL', name: 'ALL' },
        { code: 'US', name: 'United States' },
        { code: 'GB', name: 'United Kingdom' },
        { code: 'CA', name: 'Canada' },
        { code: 'AU', name: 'Australia' },
        { code: 'DE', name: 'Germany' },
        { code: 'FR', name: 'France' },
        { code: 'IT', name: 'Italy' },
        { code: 'ES', name: 'Spain' },
        { code: 'NL', name: 'Netherlands' },
        { code: 'SE', name: 'Sweden' },
        { code: 'CH', name: 'Switzerland' },
        { code: 'BE', name: 'Belgium' },
        { code: 'NO', name: 'Norway' },
        { code: 'AT', name: 'Austria' },
        { code: 'DK', name: 'Denmark' },
        { code: 'IE', name: 'Ireland' },
        { code: 'FI', name: 'Finland' },
    ];

    const sources = [
        { code: 'tb', name: 'Taboola' },
        { code: 'fb', name: 'Facebook' },
        { code: 'ob', name: 'Outbrain' },
        { code: 'na', name: 'Other' },
    ];

    const handleAssignNewFeed = () => {

        let index = 0

        if (form.supply_feeds?.length) {
            setForm(prevState =>
                ({
                    ...prevState,
                    supply_feeds: [{}, ...prevState.supply_feeds]
                })
            )
        } else {
            setForm(prevState =>
                ({
                    ...prevState,
                    supply_feeds: [
                        {}
                    ]
                })
            )
        }
    }


    const handleChangeSupplyFeed = (event, key) => {


        let index = key
      //  console.log(index, event.target.value, event.target.checked, key, form.supply_feeds.slice(index, 1), form.supply_feeds.length)
        if (key == 'new') {
            index = form.supply_feeds.length
        }
        let value = (event.target.name == "active" || event.target.name == "filter_referer" || event.target.name == "spin") ? event.target.checked : event.target.value


        setForm(prevState =>
            ({
                ...prevState,
                supply_feeds: [
                    ...prevState.supply_feeds.slice(0, index),
                    {...prevState.supply_feeds[index], [event.target.name]: value},
                    ...prevState.supply_feeds.slice(index + 1)

                ]
            })
        )


    };


    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(false)
        setEdit(false)
        setForm({})


    };

    return (
        <MainLayout>

            {/*<UrlChecker setOpen={setOpenUrlChecker} open={openUrlChecker} defaultUrl={form.url} />*/}
            <Success successMessage={editMessage} setSuccessMessage={setEditMessage}>
                {editMessage?.message}
            </Success>
            <SupplyFeedsModal open={openSupplyFeeds} setOpen={setOpenSupplyFeeds} row={row}/>
            <SupplyFeedDetailsTable supplyFeedId={detailsId} demandFeedId={row?.id} open={openDetails} setOpen={setOpenDetails}/>
            <SelectOptionDialog
                selectedValue={selectedValueDetails}
                open={openDetailsDialog}
                onClose={handleCloseDetails}
                options={optionsDialogDetails}
            />

            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Grid container spacing={3}>


                    <Grid item xs={12}>

                        <Paper sx={{p: 2, display: 'flex', flexDirection: 'column'}}>

                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                borderRadius: '12px',

                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    flexGrow: 1,
                                }}>
                                    <Title>Demand Feeds</Title>
                                </Box>
                                <Box sx={{
                                    display: 'flex',

                                }}>
                                    <Button variant="contained" onClick={() => setOpen(true)}>+ Add Demand Feed</Button>
                                </Box>

                            </Box>

                                    <DataGrid
                                        // filterModel={{
                                        //     items: [{ columnField: 'id', operatorValue: '>', value: '180' }],
                                        // }}
                                        rows={!loading ? demandFeeds : []}
                                        columns={columns}
                                        pageSize={50}
                                        autoHeight={true}
                                        onCellEditCommit={onCellEditCommit}
                                        columnVisibilityModel={{
                                            data_checker: false,
                                            internal_name: false,
                                            url: false,
                                            provider: false,
                                            user_demand_provider: false,
                                        }}
                                        rowsPerPageOptionsSkeleton
                                        disableSelectionOnClick
                                        //getRowHeight={() => 'auto'}
                                        //getEstimatedRowHeight={() => 200}
                                        density={"compact"}

                                        sx={{
                                            mt: 3,
                                            minHeight: 600
                                        }}
                                        //density={"compact"}
                                        components={{
                                            LoadingOverlay: LoadingSkeleton,
                                            Toolbar: GridToolbar,

                                        }}
                                        componentsProps={{
                                            toolbar: {
                                                showQuickFilter: true,
                                                quickFilterProps: {debounceMs: 500},
                                            },
                                        }}
                                        loading={loading}
                                    />


                            <Drawer
                                anchor={"right"}
                                open={open}
                                onClose={toggleDrawer(false)}
                            >

                                <Box
                                    sx={{
                                        marginTop: 3,
                                        mx: 5,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        width: 350
                                    }}>
                                    <Box component={"form"} onSubmit={handleSubmit}>
                                        <Title>{ form.demand_partner_id ? "Edit":"Create New"} Feed</Title>
                                        <Box>
                                            <FormControl fullWidth sx={{mt: 1}} size={"small"} required                                                     margin={"normal"}
                                            >
                                                <InputLabel id="demand_partner_id">Demand Partner</InputLabel>
                                                <Select
                                                    labelId="demand_partner_id"
                                                    id="demand_partner_id"
                                                    label="Demand Partner"
                                                    value={form.demand_partner_id ?? ''}
                                                    size={"small"}
                                                    name="demand_partner_id"
                                                    required
                                                    fullWidth
                                                    onChange={handleChange}
                                                >
                                                    {demandPartners.map((item) => (<MenuItem key={item.id}
                                                                                             value={item.id}>{item.name}</MenuItem>))}

                                                </Select>

                                            </FormControl>
                                            <FormControl fullWidth size={"small"} required margin="normal">
                                                <InputLabel id="type_id">Type</InputLabel>
                                                <Select
                                                    labelId="demand_partner_id"
                                                    id="type_id"
                                                    label="Demand Partner"
                                                    value={form.type_id ?? ''}
                                                    size={"small"}
                                                    name="type_id"
                                                    required
                                                    fullWidth
                                                    onChange={handleChange}
                                                >
                                                    {demandFeedTypes.map((item) => (<MenuItem key={item.id}
                                                                                              value={item.id}>{item.name}</MenuItem>))}

                                                </Select>

                                            </FormControl>
                                            <FormControl variant="outlined"  size={"small"} fullWidth
                                                         required={true}                                                     margin={"normal"}
                                            >
                                                <InputLabel onChange={handleChange}>Url</InputLabel>
                                                <OutlinedInput
                                                    label="Url"
                                                    size={"small"}
                                                    type="text"
                                                    multiline

                                                    name={"url"}
                                                    id="url"
                                                    value={form.url}
                                                    onChange={handleChange}
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={() => {
                                                                    searchParams.set('checker', true)
                                                                    searchParams.set('url', form.url)
                                                                    searchParams.set('device', form.desktop ? "d":"m")
                                                                    setSearchParams(searchParams)
                                                                }}
                                                                disabled={!form.url}
                                                                edge="end"
                                                            >
                                                                {form.url ? <SmartToy color={"primary"}/> :
                                                                    <SmartToy color={"inherit"}/>}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                    label="Url"
                                                />
                                            </FormControl>


                                            <Alert severity="info">Macros supported: {"{q}"} for the
                                                keyword, {"{sub_id}"} freestyle parameter, {"{sf_id}"} for sending the
                                                feed_id, {"{vertical}"} for sending the vertical, {"{click_id}"} for sending our click_id</Alert>


                                            <input
                                                value={form.id}
                                                name="id"
                                                type="hidden"
                                                id="id"
                                            />

                                            <TextField
                                                required
                                                fullWidth
                                                margin={"normal"}

                                                value={form.needle}
                                                name="needle"
                                                onChange={handleChange}
                                                label="Needle"
                                                type="text"
                                                id="needle"
                                                size={"small"}
                                            />
                                            <TextField
                                                required
                                                fullWidth
                                                onChange={handleChange}
                                                value={form.capping}
                                                name="capping"
                                                label="Capping"
                                                type="number"
                                                size={"small"}
                                                id="capping"
                                                margin={"normal"}

                                            />

                                            <Typography variant={"h6"} sx={{mt: 1}}
                                                        color={"primary"}>Targeting</Typography>
                                            <FormGroup>
                                                <FormControlLabel onChange={handleChange} defaultChecked={form.desktop ? true:false}
                                                                  checked={form.desktop ? true:false} name="desktop"
                                                                  control={<Checkbox/>} label="Desktop"/>
                                                <FormControlLabel control={<Checkbox/>} defaultChecked={form.mobile ? true:false}
                                                                  checked={form.mobile ? true:false} name="mobile"
                                                                  onChange={handleChange} label="Mobile"/>
                                            </FormGroup>

                                            <TextField
                                                id="outlined-multiline-flexible"
                                                label="Note"
                                                multiline
                                                fullWidth
                                                sx={{mt: 2}}
                                                name="note"
                                                rows={5}
                                                value={form.note ?? ''}
                                                onChange={handleChange}
                                            />



                                            <FormGroup>
                                                <FormControlLabel control={<Switch
                                                    checked={form.status ? true:false}
                                                    name='status'
                                                    value={form.status}
                                                    inputProps={{'aria-label': 'controlled'}}
                                                    onChange={handleChange}
                                                    label="Active"
                                                />} label="Active"/>
                                            </FormGroup>


                                        </Box>
                                        <Button variant="outlined" sx={{my: 1}} color={"success"} startIcon={<AddCircle />}
                                                onClick={handleAssignNewFeed}>
                                            Create New Supply Feed
                                        </Button>



                                        {form.supply_feeds?.length > 1 &&
                                            <Alert severity="warning">Demand pulled automatically will be assigned to
                                                the last supply assigned — It doesn't matter if they are active or
                                                not!</Alert>
                                        }

                                        {form.supply_feeds?.map((item, key) =>
                                            <Box
                                                sx={{
                                                    border: "1px solid", // Set the border width and style
                                                    borderColor: "primary.main", // Set the border color
                                                    borderRadius: 2, // Add border radius for rounded corners
                                                    p: 2, // Add padding inside the box
                                                    my: 2,
                                                }}
                                                key={key}
                                            >

                                                {item.id && <div>
                                                    <Typography variant={"subtitle1"} sx={{mt: 1}}
                                                                color={"primary"}>Supply Feed
                                                        Id: {item.id} </Typography>
                                                    <Typography variant={"caption"}
                                                                color={"info"}>Created
                                                        at {new Date(item.created_at).toLocaleDateString()} </Typography>
                                                </div>}


                                                <input
                                                    value={item.id}
                                                    name="supply_feed_id"
                                                    type="hidden"
                                                    id="id"
                                                />
                                                <TextField
                                                    size={"small"}
                                                    fullWidth
                                                    margin={"normal"}
                                                    margin={"normal"}

                                                    value={item.name ? item.name:''}
                                                    onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                    name="name"
                                                    label="Supply Feed Name"

                                                    type="text"
                                                    id="supply_feed_name"
                                                />

                                                <FormControl fullWidth size={"small"}                                            margin={"normal"}
                                                >
                                                    <InputLabel id="country">Country</InputLabel>
                                                    <Select
                                                        labelId="country"
                                                        id="country"
                                                        onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                        name="country"
                                                        value={item.country ?? ''}
                                                        label="Country"
                                                        size={"small"}
                                                        fullWidth
                                                    >
                                                        {tier1Countries.map((country) => (
                                                            <MenuItem key={country.code} value={country.code}>
                                                                {country.name}
                                                            </MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>
                                                <FormControl fullWidth size={"small"}                                            margin={"normal"}
                                                >
                                                    <InputLabel id="source">Source</InputLabel>
                                                    <Select
                                                        labelId="source"
                                                        id="source"
                                                        onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                        name="source"
                                                        value={item.source ?? ''}
                                                        label="Source"
                                                        size={"small"}
                                                        fullWidth
                                                    >
                                                        {sources.map((source) => (
                                                            <MenuItem key={source.code} value={source.code}>
                                                                {source.name}
                                                            </MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>
                                                <FormControl fullWidth size={"small"}                                         margin={"normal"}
                                                >
                                                    <InputLabel id="supply_feed_keyword_id">Keywords List</InputLabel>
                                                    <Select
                                                        labelId="supply_feed_keyword_id"
                                                        id="supply_feed_keyword_id"
                                                        onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                        name="supply_feed_keyword_id"
                                                        value={item.supply_feed_keyword_id ?? ''}
                                                        label="Keywords List"
                                                        size={"small"}
                                                        fullWidth
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {keywordsList?.map((keyword) => (
                                                            <MenuItem key={keyword.id} value={keyword.id}>
                                                                {keyword.name}
                                                            </MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>


                                                <FormControl fullWidth size={"small"}                                                 margin={"normal"}
                                                >
                                                    <InputLabel id="supply_partner_id">Supply Partner</InputLabel>
                                                    <Select
                                                        labelId="supply_partner_id"
                                                        id="supply_partner_id"
                                                        onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                        name="user_id"
                                                        value={item.user_id ?? ''}
                                                        label="Supply Partner"
                                                        disabled={item.id ? true:false}
                                                        size={"small"}
                                                        fullWidth
                                                    >
                                                        {supplyPartners.map((partner) => (<MenuItem key={partner.id}
                                                                                                 value={partner.id}>{partner.id} - {partner.name}</MenuItem>))}

                                                    </Select>
                                                </FormControl>

                                                <TextField
                                                    margin="normal"
                                                    fullWidth
                                                    onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                    size={"small"}
                                                    value={item.capping ? item.capping : ''}
                                                    name="capping"
                                                    label="Supply Capping"
                                                    type="number"
                                                    inputProps={{min: 0, max: form.capping}}
                                                    id="supply_feed_capping"
                                                />
                                                <TextField
                                                    margin="normal"
                                                    fullWidth
                                                    onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                    size={"small"}
                                                    value={(typeof item.antifraud_check !== 'undefined') ? item.antifraud_check : 20}
                                                    inputProps={{step: 5, max: 100, min: 0}}
                                                    name="antifraud_check"
                                                    label="AntiFraud Check %"
                                                    type="number"
                                                    id="antifraud_check"
                                                />
                                                <TextField
                                                    margin="normal"
                                                    fullWidth
                                                    onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                    size={"small"}
                                                    value={
                                                        (item.margin) ? item.margin
                                                            :
                                                        (item.margins !== undefined && item.margins.length)
                                                            ? item.margins[0].margin
                                                            : ''

                                                    }


                                                    inputProps={{step: 0.1, max: 1, min: 0}}
                                                    name="margin"
                                                    label="Margin for pub (decimal 0 to 1)"
                                                    type="number"
                                                    id={item.id+"-margin"}
                                                />
                                                <TextField
                                                    margin="normal"
                                                    fullWidth
                                                    value={item.internal_name ? item.internal_name:''}
                                                    name="internal_name"
                                                    label="Internal Name (only for Unicorn and Zenloop)"
                                                    onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                    type="text"
                                                    id="internal_name"
                                                    size={"small"}
                                                />
                                                <FormGroup label="Active">
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={item.active ? true : false}
                                                                name='active'
                                                                value={item.active}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                                onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                            />
                                                        }
                                                        label="Active"  // Label is here
                                                    />
                                                </FormGroup>

                                                <FormGroup label="Filter Referer">
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={item.filter_referer ? true : false}
                                                                name='filter_referer'
                                                                value={item.filter_referer}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                                onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                            />
                                                        }
                                                        label="Filter Referer"  // Label is here
                                                    />
                                                </FormGroup>
                                                <FormGroup label="Spin">
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={item.spin ? true : false}
                                                                name='spin'
                                                                value={item.filter_referer}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                                onChange={(event) => handleChangeSupplyFeed(event, key)}
                                                            />
                                                        }
                                                        label="Spin [ZL]"  // Label is here
                                                    />
                                                </FormGroup>
                                            </Box>
                                        )}

                                        <Box>
                                            <Button
                                                fullWidth
                                                variant={"outlined"}
                                                type={"submit"}
                                                sx={{mt: 3, mb: 2}}
                                            >
                                                {!edit ? "Create" : "Save Changes"}
                                            </Button>
                                        </Box>

                                    </Box>
                                </Box>


                            </Drawer>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>


        </MainLayout>

    )
}


export default SupplyFeeds